import copy from "copy-to-clipboard"

import toast from "./toast"

// 复制 number
export function customCopy(val: any) {
  try {
    copy(val)
    toast(t("CopiedToClipboardSuccessfully"), 2e3)
  } catch (error) {
    toast(t("CopyFailed"), 2e3)
  }
}
